import { render, staticRenderFns } from "./InputWarranty.vue?vue&type=template&id=713ef3aa&lang=html"
import script from "./InputWarranty.vue?vue&type=script&lang=js"
export * from "./InputWarranty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports